// Loader-data plumbing kept out of -home-progressive so the statically-bundled
// route definition does not pull the home UI (and its fixtures) into the entry
// chunk; the lazy route component imports the UI module instead.
import type { ClassCardItem, FeatureRequestItem } from '@/lib/api/v2/homepage';

export type HomeSectionResult<T> = { ok: true; data: T } | { ok: false };

const toHomeSectionResult = async <T>(promise: Promise<T>): Promise<HomeSectionResult<T>> => {
  try {
    const data = await promise;
    return { ok: true, data };
  } catch {
    return { ok: false };
  }
};

export interface HomeLoaderData {
  featureRequestsPromise: Promise<HomeSectionResult<FeatureRequestItem[]>>;
  upcomingClassesPromise: Promise<HomeSectionResult<ClassCardItem[]>>;
}

export const createHomeLoaderData = (
  getFeatureRequests: () => Promise<FeatureRequestItem[]>,
  getUpcomingClasses: () => Promise<ClassCardItem[]>
): HomeLoaderData => ({
  featureRequestsPromise: toHomeSectionResult(getFeatureRequests()),
  upcomingClassesPromise: toHomeSectionResult(getUpcomingClasses()),
});
